module.exports = __webpack_public_path__ + "static/img/18.60b45a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/18.png
// module id = 0+k9
// module chunks = 0